import {i18n} from '@yourcoach/i18n';

import type {CoreCoachInvitesSendParams} from '../../../../api/types/core/methods';
import type {InviteRecipient} from '../types';
import type {SendInvitesParams} from './types';

import {isDefined} from '../../../../utils/typecheck';

export type SendInvitesResult = {
  message: string;
  title: string;
};

export abstract class SendInvitesStrategy {
  private readonly DEFAULT_SUCCESS_MESSAGE = '';

  protected constructor(private readonly sendInviteParams: SendInvitesParams) {}

  abstract sendInvites(): Promise<SendInvitesResult>;

  protected getDefaultSuccessMessage(): string {
    return this.DEFAULT_SUCCESS_MESSAGE;
  }

  protected getDefaultSuccessTitle(recipientsCount: number): string {
    return i18n.t('shared:invitation_success', {count: recipientsCount});
  }

  protected getRecipientsByEmail(): InviteRecipient[] {
    return (
      this.sendInviteParams.recipients?.filter(
        ({email, user_id}) => isDefined(email) && !isDefined(user_id),
      ) ?? []
    );
  }

  protected getRecipientsByName(): InviteRecipient[] {
    return (
      this.sendInviteParams.recipients?.filter(({user_id}) =>
        isDefined(user_id),
      ) ?? []
    );
  }

  protected mapInviteRecipientsToRequestRecipients(
    recipients: InviteRecipient[],
  ): NonNullable<CoreCoachInvitesSendParams['recipients']> {
    return recipients?.map(({email, user_id}) => ({email, user_id})) ?? [];
  }
}
